<template>
  <div class="recharge_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('account.manage') }}
      </div>
    </div>
    <div
      v-if="isVerified"
      class="wrap_box warp1"
    >
      <p><span>{{ allNum }}</span> {{ $t('account.withdrawalAccounts') }}</p>
    </div>
    <div
      v-if="isVerified"
      class="wrap_box warp2"
    >
      <div
        v-for="i in data.bank"
        :key="i.id"
        class="item"
      >
        <img
          :src="require('../images/user/recharge'+i.type+'.png')"
          alt=""
        >
        <div class="item_detail">
          <p class="user_name ari_font">
            {{ i.bank }}
          </p>
          <p class="user_num">
            {{ i.account }}
          </p>
        </div>
        <div
          class="del"
          @click="delCard(i.id)"
        />
      </div>
    </div>
    <div
      v-if="isVerified"
      class="basic_btn"
      @click="$router.push('/addcountUsdt')"
    >
      {{ $t('account.add') }}
    </div>
    <van-popup
      v-model="passwordPopup"
      :close-on-click-overlay="false"
      round
      position="bottom"
    >
      <div class="psw_box">
        <div
          class="password_back"
          @click="$router.back()"
        >
          {{ $t('account.securityPasswordBack') }}
        </div>
        <p class="password_title">
          {{ $t('account.securityPassword') }}
        </p>
        <p class="password_tip">
          {{ $t('account.securityPasswordTip') }}
        </p>
        <van-password-input
          :value="psdVal"
          :mask="true"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <p
          v-if="passwordError"
          class="password_error"
        >
          {{ $t('account.securityPasswordRetry') }}
        </p>
        <div class="keybord_box">
          <div class="keybord">
            <div
              v-for="i in 9"
              :key="i"
              class="key_item"
              @click="onInput(i)"
            >
              <div class="key_inner">
                {{ i }}
              </div>
            </div>
            <div class="key_item no_bg">
              <div class="key_inner" />
            </div>
            <div
              class="key_item"
              @click="onInput(0)"
            >
              <div class="key_inner">
                0
              </div>
            </div>
            <div
              class="key_item no_bg x"
              @click="onDelete"
            >
              <div class="key_inner">
                x
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
    import Vue from 'vue'
    import Fetch from '../../utils/fetch'
    import { Dialog, PasswordInput, Popup } from 'vant'

    Vue.use(Dialog).use(PasswordInput).use(Popup)

    export default {
        name: "Account",
        data() {
            return {
                allNum:0,
                data: {
                    bank: []
                },
                isVerified: false,
                passwordPopup: true,
                psdVal: '',
                showKeyboard: true,
                isVerifying: false,
                passwordError: false
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        methods: {
            delCard(id){
                Dialog.confirm({
                    title: this.$t('utils.prompt'),
                    message: this.$t('account.deleteConfirm'),
                    confirmButtonText: this.$t('utils.confirm'),
                    cancelButtonText: this.$t('utils.cancel')
                }).then(() => {
                    Fetch('/user/bank_remove', {id: id}).then(() => {
                        this.data.bank = this.data.bank.filter(item => item.id !== id);
                        this.allNum = this.data.bank.length;
                    });
                }).catch(() => {});
            },
            onInput(key) {
                if (this.isVerifying) {
                    return;
                }
                this.psdVal = (this.psdVal + key).slice(0, 6);
                this.passwordError = false;
                if (this.psdVal.length === 6) {
                    this.verifyPassword();
                }
            },
            onDelete() {
                if (this.isVerifying) {
                    return;
                }
                this.psdVal = this.psdVal.slice(0, -1);
                this.passwordError = false;
            },
            verifyPassword() {
                if (this.isVerifying || this.psdVal.length !== 6) {
                    return;
                }
                this.isVerifying = true;
                Fetch('/user/account_bank', {passwd: this.psdVal}).then(r=>{
                    this.data = r.data;
                    this.allNum = r.data.count;
                    this.isVerified = true;
                    this.passwordPopup = false;
                    this.psdVal = '';
                    this.passwordError = false;
                    this.isVerifying = false;
                }).catch(() => {
                    this.psdVal = '';
                    this.passwordError = true;
                    this.isVerifying = false;
                });
            }
        }
    };
</script>

<style lang="less" scoped>
    .red_top_bg {
        position: relative;
    }
  

    .warp1 {
        padding: 0 20px;
        height: 40px;

        p {
            font-size: 14px;
            line-height: 40px;
            color: rgba(0,0,0,.8);
            font-weight: bold;

            span {
                color: #F03041;
            }
        }
    }

    .ari_font {
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(0,0,0,.8);
        line-height: 20px;
    }

    .warp2 {
        padding: 0 15px;
        margin-top: 12px;

        .item {
            padding: 14px 0 11px 0;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            border-bottom: 1px solid #ECECEC;

            &:last-child {
                border-bottom: none;
            }

            img {
                width: 30px;
                height: 30px;
            }

            .item_name {
                width: 65px;
            }
      .item_detail{
        margin-left: 10px;
      }

            .user_num {
                height: 17px;
                font-size: 12px;
                font-weight: 600;
                color: rgba(0,0,0,.6);
                line-height: 17px;
                margin-top: 10px;
            }

            .del {
                width: 20px;
                height: 20px;
                background: url(../images/item/del.png) no-repeat center center;
                background-size: 100% 100%;
                margin: 0 8px 0 auto;
            }
        }
    }

    .basic_btn {
        margin: 50px auto 0 auto;
    }

    /deep/ .van-popup--bottom {
        padding-bottom: 15px;
        border-radius: 0;
    }

    .psw_box {
        position: relative;
        min-height: 270px;
        padding: 24px 16px 0;
    }

    .password_back {
        position: absolute;
        top: 16px;
        left: 16px;
        color: #061429;
        font-size: 14px;
        line-height: 24px;
    }

    .password_title {
        color: #061429;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        text-align: center;
    }

    .password_tip {
        margin: 6px 16px 20px;
        color: #8f97a6;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
    }

    .password_error {
        height: 18px;
        margin-top: 10px;
        color: #ff1724;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
    }

    .keybord_box {
        margin-top: 20px;
    }

    .keybord {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .key_item {
        width: 33.3333%;
        height: 44px;
        padding: 2px 4px;
        box-sizing: border-box;
    }

    .key_inner {
        height: 40px;
        border-radius: 6px;
        background: #f4f5fb;
        color: #061429;
        font-size: 18px;
        line-height: 40px;
        text-align: center;
    }

    .no_bg .key_inner {
        background: transparent;
    }

    .recharge_wrap {
        min-height: 100vh;
        padding-bottom: 88px;
        box-sizing: border-box;
        background: #f4f5fb;
        color: #061429;
        font-size: 12px;
    }

    .red_top_bg {
        position: sticky;
        top: 0;
        z-index: 10;
        height: 50px;
        background: #f7f8fd;
    }

    .big_tit {
        height: 50px;
        color: #202637;
        font-size: 14px;
        font-weight: 500;
        line-height: 50px;
        text-align: center;
    }

    .back_left {
        position: absolute;
        left: 14px;
        top: 11px;
        width: 28px;
        height: 28px;
        background: none;
    }

    .back_left::before {
        content: '';
        position: absolute;
        left: 10px;
        top: 7px;
        width: 10px;
        height: 10px;
        border-left: 2px solid #071426;
        border-bottom: 2px solid #071426;
        transform: rotate(45deg);
    }

    .wrap_box {
        margin: 16px;
        border-radius: 12px;
        background: #fff;
        box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
    }

    .warp1 {
        height: 52px;
        padding: 0 16px;
    }

    .warp1 p {
        color: #061429;
        font-size: 14px;
        line-height: 52px;
    }

    .warp1 p span {
        color: #ff1724;
    }

    .warp2 {
        margin-top: 0;
        padding: 0 14px;
    }

    .warp2 .item {
        min-height: 70px;
        padding: 12px 0;
        border-color: #f0f2f7;
    }

    .warp2 .item img {
        width: 36px;
        height: 36px;
        border-radius: 10px;
    }

    .warp2 .item .item_detail {
        min-width: 0;
        margin-left: 12px;
    }

    .ari_font {
        height: 20px;
        color: #061429;
        font-size: 14px;
        line-height: 20px;
    }

    .warp2 .item .user_num {
        overflow: hidden;
        margin-top: 5px;
        color: #8f97a6;
        font-size: 12px;
        font-weight: 400;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .warp2 .item .del {
        width: 18px;
        height: 18px;
        opacity: .56;
    }

    .basic_btn {
        width: calc(100% - 32px);
        height: 44px;
        margin: 22px auto 0;
        border-radius: 12px;
        background: linear-gradient(135deg, #ff4e58 0%, #ff1724 100%);
        box-shadow: 0 8px 18px rgba(255, 49, 63, .18);
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        line-height: 44px;
        text-align: center;
    }
</style>
